import React from 'react';
import styles from './FilesList.module.scss';
import File from '../File/File';
import I18n from '../../../I18n/I18n/I18n';
export default function FilesList(_ref) {
  var readonly = _ref.readonly,
    _onCancel = _ref.onCancel,
    _onDelete = _ref.onDelete,
    size = _ref.size,
    disabled = _ref.disabled,
    files = _ref.files;
  if (Array.isArray(files) && files.length) {
    return /*#__PURE__*/React.createElement("ol", {
      className: styles.container
    }, files.map(function (file, index) {
      return /*#__PURE__*/React.createElement(File, {
        disabled: disabled || readonly,
        errorMessage: file.errorMessage,
        fileSize: file.size,
        key: file.upload.uuid || index,
        location: file.location,
        mimeType: file.type,
        name: file.name,
        onCancel: function onCancel() {
          return _onCancel(file);
        },
        onDelete: function onDelete() {
          return _onDelete(file);
        },
        progress: file.upload ? parseFloat(file.upload.progress).toFixed(1) : null,
        size: size,
        status: file.status
      });
    }));
  } else if (disabled) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.empty
    }, /*#__PURE__*/React.createElement(I18n, {
      i18n: "@dm/components.file-input.no-files"
    }));
  } else {
    return null;
  }
}